<div class="alert alert-warning" role="alert">
  Your assigned role does not have privilege to access this feature
</div>